export default __webpack_public_path__ + "8b9326b6e85be324f5abf243c6313f23.wav";